// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 28Wh6oQMGtkZtGs1aVzLHN
// Component: jsKB1dIQ9r
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import HomepageNavbar from "../../HomepageNavbar"; // plasmic-import: xTJEhzpCCql/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_origin.module.css"; // plasmic-import: 28Wh6oQMGtkZtGs1aVzLHN/projectcss
import sty from "./PlasmicGalerija.module.css"; // plasmic-import: jsKB1dIQ9r/css
import img7137JpgI7GWu0Z5 from "../bela_griva/images/img7137Jpg.jpg"; // plasmic-import: I_7GWu0z5/picture
import img7247Jpg2CkxdByVb from "../bela_griva/images/img7247Jpg.jpg"; // plasmic-import: 2ckxdByVB/picture
import img7250JpgDFuNn7HVp from "../bela_griva/images/img7250Jpg.jpg"; // plasmic-import: dFuNN7HVp/picture
import img7293JpgMiZ7SujyP from "../bela_griva/images/img7293Jpg.jpg"; // plasmic-import: MiZ7SujyP/picture
import img7266JpgWFrX2NgwT from "../bela_griva/images/img7266Jpg.jpg"; // plasmic-import: wFrX2NgwT/picture
import img7348JpgW7E5ZxCaa from "../bela_griva/images/img7348Jpg.jpg"; // plasmic-import: w7e5zxCaa/picture
import img7389JpgVaYgHiEs from "../bela_griva/images/img7389Jpg.jpg"; // plasmic-import: VAYgHi_es/picture
import img7484JpgVdyvyN5J from "../bela_griva/images/img7484Jpg.jpg"; // plasmic-import: Vdyvy-N5j/picture
import img7497JpgEJjreVnCy from "../bela_griva/images/img7497Jpg.jpg"; // plasmic-import: eJJREVnCY/picture
import img7524JpgZ0QYkRtN7 from "../bela_griva/images/img7524Jpg.jpg"; // plasmic-import: Z0qYKRtN7/picture

export const PlasmicGalerija__VariantProps = new Array();

export const PlasmicGalerija__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicGalerija__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <HomepageNavbar
            data-plasmic-name={"homepageNavbar"}
            data-plasmic-override={overrides.homepageNavbar}
            className={classNames("__wab_instance", sty.homepageNavbar)}
          />

          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Galerija"}
          </div>
          <div className={classNames(projectcss.all, sty.columns___7RWv7)}>
            <div className={classNames(projectcss.all, sty.column__fawys)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img___79Dsm)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7137JpgI7GWu0Z5,
                  fullWidth: 3120,
                  fullHeight: 4680,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column__ci3JK)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__xzLv0)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7247Jpg2CkxdByVb,
                  fullWidth: 3120,
                  fullHeight: 4680,
                  aspectRatio: undefined
                }}
              />
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.columns__nuKve)}>
            <div className={classNames(projectcss.all, sty.column___2U1Vu)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__sksFz)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7250JpgDFuNn7HVp,
                  fullWidth: 4522,
                  fullHeight: 3015,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column__pp73X)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__dffOb)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7293JpgMiZ7SujyP,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.columns___18KaG)}>
            <div className={classNames(projectcss.all, sty.column___50QM2)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__vN8F)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7266JpgWFrX2NgwT,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column__uVhng)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__zTvA5)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7348JpgW7E5ZxCaa,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.columns__w3UYi)}>
            <div className={classNames(projectcss.all, sty.column__dLKu1)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__zqFh7)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7389JpgVaYgHiEs,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column__sAcLs)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__fLed)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7484JpgVdyvyN5J,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.columns__pjJmr)}>
            <div className={classNames(projectcss.all, sty.column__u08T0)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__he1MD)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7497JpgEJjreVnCy,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column___5H3If)}>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__yMyHk)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"654px"}
                loading={"lazy"}
                src={{
                  src: img7524JpgZ0QYkRtN7,
                  fullWidth: 4680,
                  fullHeight: 3120,
                  aspectRatio: undefined
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "homepageNavbar", "text"],
  homepageNavbar: ["homepageNavbar"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicGalerija__ArgProps,
          internalVariantPropNames: PlasmicGalerija__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicGalerija__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGalerija";
  } else {
    func.displayName = `PlasmicGalerija.${nodeName}`;
  }
  return func;
}

export const PlasmicGalerija = Object.assign(
  // Top-level PlasmicGalerija renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    homepageNavbar: makeNodeComponent("homepageNavbar"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicGalerija
    internalVariantProps: PlasmicGalerija__VariantProps,
    internalArgProps: PlasmicGalerija__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicGalerija;
/* prettier-ignore-end */
